import React, { useState, useCallback, useEffect } from "react";
import Form from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";
import LoadingButton from "../../components/loadingButton";
import ErrorMessage from "../../components/errorMessage";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import { useAuth } from "../../hooks/useAuth";
import InputWithPostfix from "../../components/inputWithPostfix";
import formStyles from "../../components/form/style.module.css";
import styles from "./style.module.css";

const promptSchema = {
  type: "object",
  required: ["yellow_at", "red_at"],
  properties: {
    yellow_at: {
      title: "Yellow at",
      type: "number",
      minimum: 0,
    },
    red_at: {
      title: "Red at",
      type: "number",
      minimum: 0,
    },
  },
};

const widgets = {
  yellow_at: InputWithPostfix,
  red_at: InputWithPostfix,
};

const PromptForm = () => {
  const { auth } = useAuth();
  let monitorBy =
    auth?.monitorBy?.charAt(0).toUpperCase() + auth?.monitorBy?.slice(1);

  if (monitorBy === 'Days') {
    monitorBy = 'Track Days';
  } else if (monitorBy === 'Sessions') {
    monitorBy = 'Sessions';
  } else if (monitorBy === 'Laps') {
    monitorBy = 'Miles';
  }
  const axiosPrivate = useAxiosPrivate();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [extraErrors, setExtraErrors] = useState({});

  const promptUiSchema = {
    "ui:classNames": `${formStyles.formInner_p0} ${styles.form_inner}`,
    "ui:rootFieldId": "prompt_form",
    yellow_at: {
      "ui:widget": InputWithPostfix,
      "ui:classNames": `${formStyles.form_field} ${formStyles.col_6} ${styles.snapshot_group_field}`,
      "ui:options": {
        postfix: `${monitorBy} left`,
        minimum: 1,
        maximum: 1000,
        postfixClass: styles.postfix,
      },
    },
    red_at: {
      "ui:widget": InputWithPostfix,
      "ui:classNames": `${formStyles.form_field} ${formStyles.col_6} ${styles.snapshot_group_field}`,
      "ui:options": {
        postfix: `${monitorBy} left`,
        minimum: 1,
        maximum: 1000,
        postfixClass: styles.postfix,
      },
    },
    "ui:submitButtonOptions": {
      props: {
        className: formStyles.form_btn,
      },
      submitText: "Save",
    },
  };

  const onFormSubmit = (data) => {
    let tempData = { ...data };
    setFormData(tempData);
    updateProfile(tempData);
  };

  const fetchProfileInfo = useCallback(async () => {
    try {
      let url = `user/profile`;
      let options = {
        method: "GET",
        url,
      };
      await axiosPrivate(options)
        .then((response) => {
          if (response.data.status === 1) {
            let tempData = {
              yellow_at: response.data.user.yellow_at,
              red_at: response.data.user.red_at,
            };
            setFormData(tempData);
          }
        })
        .catch((err) => {
          if (err.response) {
            // console.error('err.res', err.response.data);
          }
        });
    } catch (error) {
      // console.error('error', error);
    }
    // eslint-disable-next-line 
  }, []);

  const updateProfile = useCallback(
    async (data) => {
      setLoading(true);
      setErrorMessage("");
      try {
        let url = `user/update-snapshot`;
        let options = {
          method: "PUT",
          url,
          data,
        };
        await axiosPrivate(options)
          .then((response) => {
            if (response.data.status === 1) {
              fetchProfileInfo();
              setExtraErrors({});
            }
            setLoading(false);
          })
          .catch((err) => {
            if (err.response) {
              if (err.response.data.errors) {
                let tempErr = { ...extraErrors };
                for (let key in err.response.data.errors) {
                  tempErr[key] = { __errors: [err.response.data.errors[key]] };
                }
                setExtraErrors(tempErr);
              } else {
                setErrorMessage(err.response.data.message);
                setExtraErrors({});
              }
              setLoading(false);
              // setExtraErrors(err.response.data.errors);
            }
          });
      } catch (error) {
        setErrorMessage("Something went wrong");
        setLoading(false);
      }
    },
    // eslint-disable-next-line 
    []
  );

  useEffect(() => {
    fetchProfileInfo();
  }, [fetchProfileInfo]);

  return (
    <div className={styles.prompt_form}>
      <div className={styles.prompt_form_title}>Customize your Snapshot prompt</div>
      <Form
        className={`${formStyles.form} ${formStyles.form_inline}`}
        schema={promptSchema}
        uiSchema={promptUiSchema}
        widgets={widgets}
        formData={formData}
        validator={validator}
        showErrorList={false}
        extraErrors={extraErrors}
        omitExtraData={true}
        liveValidate={false}
        onSubmit={({ formData }) => {
          onFormSubmit(formData);
        }}
      >
        <div className={styles.form_actions}>
          {errorMessage && <ErrorMessage customClass={styles.error_message_profile} message={errorMessage} />}  <LoadingButton type="submit" loading={loading} title={"Save"} />
        </div>
      </Form>
    </div>
  );
};

export default PromptForm;
